<template>
  <b-modal
    lazy
    size="xl"
    class="v3_modal"
    ok-variant="v3_teal_outline"
    ok-title="Decline"
    :ok-disabled="(!isOtherChecked && !checkedReasons.length) || (isOtherChecked && !otherReason)"
    cancel-variant="v3_red_outline"
    :visible="visible"
    footer-class="border_0 justify-content-start"
    @ok="$emit('continue', checkedReasons, isOtherChecked ? otherReason : null)"
    @cancel="$emit('cancel')"
    no-close-on-backdrop
    no-close-on-esc
  >
    <template slot="modal-header-close">
      <span>Close window</span>
      <i class="mdi mdi-close-circle-outline" />
    </template>
    <b-row class="mt-4">
      <b-col>
        <p>
          Are you sure you want to decline this Job Offer? Even a brief,
          anonymous email exchange might give you more to think about or change
          your mind.
        </p>
        <p class="mt-2">
          If you are sure you want to decline this offer, it would be helpful to
          know why:
        </p>

        <b-form-checkbox
          v-for="(title, index) in declineReasons"
          :value="title"
          :key="index"
          :id="`reason_${index}`"
          v-model="checkedReasons"
        >
          {{ title }}
        </b-form-checkbox>

        <b-form-checkbox
          :value="'other'"
          :key="'other'"
          :id="`reason_other`"
          v-model="checkedReasons"
        >
          Other:
        </b-form-checkbox>
        <b-textarea :disabled="!isOtherChecked" v-model="otherReason" />
      </b-col>
    </b-row>
  </b-modal>
</template>

<script>
import Api from '@/providers/Api';

export default {
  name: 'JobProfileJobOfferMatchDeclineModal',
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      declineReasons: null,
      checkedReasons: [],
      otherReason: null,
    };
  },
  created() {
    this.getDeclineReasons();
  },
  computed: {
    isOtherChecked: function () {
      return !!this.checkedReasons.some(r => r === 'other');
    },
  },
  methods: {
    getDeclineReasons: async function () {
      try {
        this.declineReasons = await Api.getJobOfferDeclineReasons();
      } catch (error) {
        this.$toasted.error('Could not find decline reasons', {
          duration: 3000,
        });
      }
    },
  },
};
</script>

<style scoped></style>
